import type {ColorName} from '@github-ui/use-named-color'

export type NewSingleSelectOption = {
  color: ColorName
  name: string
  description: string
}

export type PersistedSingleSelectOption = NewSingleSelectOption & {
  id: string
  nameHtml: string
  descriptionHtml: string
}

export type SingleSelectOptionWithId = NewSingleSelectOption & {id: string}

export type SingleSelectOption = NewSingleSelectOption | PersistedSingleSelectOption

export const emptySingleSelectOption: SingleSelectOption = {color: 'GRAY', description: '', name: ''}
